<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="d-flex justify-content-between mb-3x">
    <h2>{{ 'COMMON_UI.FRAGEBOGEN.ORTDESSITZES.TITEL' | translate }}</h2>
    <common-ui-daten-uebernahme (picked)="form.get('ortDesSitzes').setValue($event)" [itemTemplate]="datenuebernahmeOrtDesSitzes"
                                [items]="stammdatenOrtDesSitzes"
                                [readonly]="readonly"
                                context="UnternehmenOrtDesSitzes">
    </common-ui-daten-uebernahme>
  </div>

  <div class="form-row">
    <label class="col-sm-4 col-form-label" for="ortDesSitzes{{index}}"
           title="{{ 'COMMON_UI.FRAGEBOGEN.ORTDESSITZES.LABEL' | translate }}">{{ 'COMMON_UI.FRAGEBOGEN.ORTDESSITZES.LABEL' | translate }}</label>

    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="ortDesSitzes{{objectId}}" formControlName="ortDesSitzes" id="ortDesSitzes{{index}}"
             type="text" utilsCheckValidity
             utilsControlState utilsValidationMessage/>

    </div>
  </div>

</form>

<ng-template #datenuebernahmeOrtDesSitzes let-item="item">
  <h4>
    {{item}}
  </h4>
</ng-template>
